// @flow

//import * as React from 'react';
//import Settings from 'config/Settings';


const BGMTYPE_NONE = 0;
const BGMTYPE_UI = 1;
const BGMTYPE_ZERO100 = 2;
const BGMTYPE_RACING = 3;
const BGMTYPE_MUSIC = 4;
const BGMTYPE_UI2 = 5;

window.AudioUtilsData = window.AudioUtilsData || {
  bgmType : BGMTYPE_NONE,
  bgm : null,
  countdown_01 : null
};

const data = window.AudioUtilsData;
const base_motor_volume = 0.15;
//console.log("audio: AudioUtilsData:", window.AudioUtilsData);

function getSoundArray(filename : string, extensions? : Array<string>) : Array<string> {
  if (extensions == null) {
    extensions = ["webm", "mp3"];
  }

  const prefix = (process.env.PUBLIC_URL ?? '') + '/sound/' + filename;
  return extensions.map((ext, idx)=>{
    return prefix + "." + ext;
  });
}

function playBGM(filename : string ) : any {


  stopBGMImpl();

  const src = getSoundArray(filename);

  //console.log("audio: playBGM src=", src, "AudioUtilsData=", data);
  const result = new window.Howl({
    src: src,
    autoplay: true,
    loop: true,
    volume: 1.0,
  });
  
  data.bgm = result;
  return result;
}

function stopBGMImpl(): void {
  
  if (data.bgm != null) {
    data.bgm.stop();
    data.bgm = null;
  }
}



export function play_countdown_01() : void {
  if (data.countdown_01 != null) {
    data.countdown_01.stop();
    data.countdown_01.play();
    return;
  }
  data.countdown_01 = new window.Howl({
    src: getSoundArray("countdown_01"),
    autoplay: false,
    loop: false,
    volume: 1.0,
  });
  data.countdown_01.play();
}
export function play_countdown_02() : void {
  if (data.countdown_02 != null) {
    data.countdown_02.stop();
    data.countdown_02.play();
    return;
  }
  data.countdown_02 = new window.Howl({
    src: getSoundArray("countdown_02"),
    autoplay: false,
    loop: false,
    volume: 1.0,
  });
  data.countdown_02.play();
}
export function play_camera() : void {
  if (data.camera != null) {
    data.camera.stop();
    data.camera.play();
    return;
  }
  data.camera = new window.Howl({
    src: getSoundArray("camera"),
    autoplay: false,
    loop: false,
    volume: 1.0,
  });
  data.camera.play();
}


export function play_motor01() : any {
  if (data.motor01 != null) {
    data.motor01.stop();
    data.motor01.play();
    return data.motor_01;
  }
  console.log("audio: play_motor01");
  const clip = new window.Howl({
    src: getSoundArray("motor_01"),
    autoplay: false,
    loop: false,
    volume: 1.0,
  });
  data.motor01 = clip;
  clip.play();
  return clip;
}

export function get_data(): any {
  return data;
}

export function stop_motor01() : void {
  console.log("audio: stop_motor01");
  if (data.motor01 != null) {
    data.motor01.stop();
    data.motor01 = null;
  }
}

export function stop_motor02() : void {
  if (data.motor02 != null) {
    data.motor02.stop();
    data.motor02 = null;
  }
}

export function play_motor02() : any {
  if (data.motor02 != null) {
    data.motor02.play();
    return data.motor02;
  }
  const clip = new window.Howl({
    src: getSoundArray("motor_02_loop"),
    autoplay: false,
    loop: true,
    volume: 1.0,
  });
  data.motor02 = clip;
  clip.play();
  return clip;
}


export function play_motor03() : any {
  if (data.motor03 != null) {
    data.motor03.stop();
    data.motor03.play();
    return data.motor_03;
  }
  const clip = new window.Howl({
    src: getSoundArray("motor_03"),
    autoplay: false,
    loop: false,
    volume: 1.0,
  });
  data.motor03 = clip;
  clip.play();
  return clip;
}

export function play_motorZ100() : any {
  if (data.motorZ100 != null) {
    data.motorZ100.stop();
    data.motorZ100.play();
    return data.motorZ100;
  }
  const clip = new window.Howl({
    src: getSoundArray("motor_z100"),
    autoplay: false,
    loop: false,
    volume: 1.0,
  });
  data.motorZ100 = clip;
  clip.play();
  return clip;
}

export function play_motorGT() : any {
  const clip = new window.Howl({
    src: getSoundArray("motor_high_short"),
    autoplay: false,
    loop: false,
    volume: 1.0 * base_motor_volume * 2.0,
  });
  clip.play();
  return clip;
}

export function play_goal_finish() : void {

  //HACK

  stop_drift();
  set_motor_rate(0.0);
  //stop_motor();
  if (data.finish != null) {
    data.finish.stop();
    data.finish.play();
    return;
  }
  data.finish = new window.Howl({
    src: getSoundArray("goal_finish"),
    autoplay: false,
    loop: false,
    volume: 1.0,
  });
  data.finish.play();
}

let itemPlayingCount = 0;
let lastItemPlayingTime;
export function play_item(volume?:number) : void {
  volume = volume || 1.0;
  if (volume !== 1.0) {
    if (itemPlayingCount > 4) {
      return;
    }
    if (lastItemPlayingTime == null) {
      lastItemPlayingTime = 0;
    }
    const now = Date.now();
    const old = lastItemPlayingTime;
    if (now - old < 300) {
      return;
    }
    lastItemPlayingTime = now;
  }

  ++itemPlayingCount;
  const clip = new window.Howl({
    src: getSoundArray("item"),
    autoplay: false,
    loop: false,
    volume: volume,
  });
  clip.play();
  clip.on('end', function(){
    --itemPlayingCount;
  });
}

export function play_inventory(volume?:number) : void {
  const clip = new window.Howl({
    src: getSoundArray("inventory"),
    autoplay: false,
    loop: false,
    volume: volume || 1.0,
  });
  clip.play();
}

function createMultipleClips(props: any): any {


  //let srcs : Array<string>, loop?:boolean, values? :Array<number>, extensions? : Array<string>, damp? : number
  let srcs = props.srcs;
  let loop = props.loop;
  let min = props.min;
  let max = props.max;
  let peak = props.peak;
  let minRadius = props.minRadius;
  let maxRadius = props.maxRadius;
  let baseVolume = props.volume || 1.0;
  let baseVolumes = props.volumes;
  let peak_minus_min;
  let max_minus_peak;

  let extensions = props.extensions;
  let damp = props.damp;
  let defaultValue = props.defaultValue || 0.0;
  let interp = props.interp || "cos";



  console.assert(minRadius == null || minRadius.length === srcs.length);
  console.assert(maxRadius == null || maxRadius.length === srcs.length);
  console.assert(min == null || min.length === srcs.length);
  console.assert(max == null || max.length === srcs.length);

  const interval = 1.0 / Math.max(srcs.length - 1, 1.0);
  if (min == null || min.length !== srcs.length) {
    min = srcs.map((value, idx)=>{
      return (idx - 1) * interval;
    });
  }
  if (max == null || max.length !== srcs.length) {
    max = srcs.map((value, idx)=>{
      return Math.min((idx + 1.0) * interval, 1.0);
    });
  }
  if (peak == null || peak.length !== srcs.length) {
    peak = srcs.map((value, idx)=>{
      return Math.min((idx ) * interval, 1.0);
    });
  }

  if (minRadius == null || minRadius.length !== srcs.length) {
    minRadius = srcs.map((value, idx)=>{
      return 2.0;
    });
  }
  if (maxRadius == null || maxRadius.length !== srcs.length) {
    maxRadius = srcs.map((value, idx)=>{
      return 2.0;
    });
  }
  if (baseVolumes == null) {
    baseVolumes = srcs.map((value, idx)=>{
      return baseVolume;
    });
  }

  peak_minus_min = srcs.map((value, idx)=>{
      return peak[idx] - min[idx];
    });
  max_minus_peak = srcs.map((value, idx)=>{
      return max[idx] - peak[idx];
    });

  console.log("audio:createMultipleClips, min=", min, "max=", max, "peak=", peak);

  let result: any = {clips:[], min:min, max:max, volumes : [] };
  damp = damp || 0.0;

  for (let i = 0; i < srcs.length; ++i) {
      let h = new window.Howl({
        src: getSoundArray(srcs[i], extensions),
        autoplay: false,
        loop: loop,
        volume: i === 0 ? 1.0 : 0.0,
      });
      result.clips.push(h);
      result.volumes.push(0);

  }


  result.play = function() {
    result.now = null;
    result.isPlaying = true;
    result.lastValue = defaultValue;
    for (let i = 0; i < result.clips.length; ++i) {
      result.clips[i].play();
    }
  };
  result.stop = function() {
    result.now = null;
    result.isPlaying = false;
    for (let i = 0; i < result.clips.length; ++i) {
      result.clips[i].stop();
    }
  };
  result.playing = function() {
    return result.isPlaying;
  };


  const clamp_value = true;

  function lerp(a, b, r) {
    return (b-a)*r + a;
  }

  function cos_interp(value : number, base : number, radius? : number) {
    radius = radius || 2.0;
    const r = Math.max(Math.min( (value - base) * 2.0 , 1.0), -1.0) * Math.PI;
    return Math.cos(r) * 0.5 + 0.5;
  }

  //const c0 = Math.PI / interval;
  result.setValue = function(value:number) {
    if (!result.isPlaying) {
      return;
    }
    if (window.soundMuted) {
      return;
    }
    //const valueRaw = value;
    const new_now = Date.now();

    if (result.now == null) {
      result.now = new_now;
    }
    if (result.lastValue == null) {
      result.lastValue = defaultValue;
    }
    const delta = (new_now - result.now) / 1000;
    result.now = new_now;

    value = lerp(value, result.lastValue, Math.min(delta * damp, 1.0 ) );
    result.lastValue = value;

    if (clamp_value) {
      if (value > 1.0) {
        value = 1.0;
      }
      if (value < 0.0) {
        value = 0.0;
      }
    }
    //console.log("audio: valueRaw=", valueRaw, "value=", value);



    //let sum = 0.0001;
    //console.log("audio:setValue result=", result);
    if (interp === "cos") {
      for (let i = 0; i < result.clips.length; ++i) {
        const clip = result.clips[i];
        const minValue = min[i];
        const maxValue = max[i];
        const minRadiusValue = minRadius[i];
        const maxRadiusValue = maxRadius[i];

        //const r = Math.max(Math.min( (value - rate) * 2.0 , 1.0), -1.0) * Math.PI;
        //const volume = Math.cos(r) * 0.5 + 0.5;
        let volume = 0.0;

        if (value >= minValue && value <= maxValue) {
          volume = 1.0;
        }
        else if (value < minValue) {
          volume = cos_interp(value, minValue, minRadiusValue );
        }
        else if (value > maxValue) {
          volume = cos_interp(value, maxValue, maxRadiusValue );
        }

        result.volumes[i] = volume;

        clip.volume(volume * baseVolumes[i]);
      }
    }
    else if (interp === "linear") {
      //console.log("audio: ---- setting linear volume ----");

      let totalVolume = 0.0;
      //let maxVolumeIndex = -1;
      //let maxVolume = 0;
      for (let i = 0; i < result.clips.length; ++i) {
        const clip = result.clips[i];
        const minValue = min[i];
        const maxValue = max[i];
        const peakValue = peak[i];
        const peak_minus_minValue = peak_minus_min[i];
        const max_minus_peakValue = max_minus_peak[i];

        //const r = Math.max(Math.min( (value - rate) * 2.0 , 1.0), -1.0) * Math.PI;
        //const volume = Math.cos(r) * 0.5 + 0.5;
        let volume = 0.0;
        if (value < minValue) {
          //console.log("audio: case0");
          volume = 0.0;
        }
        else if (value >= minValue && value < peakValue) {
          
          volume = (value - minValue) / peak_minus_minValue;
          //console.log("audio: src=", srcs[i], volume);
        }
        else if (value >= peakValue && value <= maxValue) {
          
          volume = 1.0 - (value - peakValue) / max_minus_peakValue;
          //console.log("audio: src(1)=", srcs[i], volume);
        } else {
          //console.log("audio: case2");
          volume = 0.0;
        }
        // if (volume < 0.4) {
        //   volume = 0.0;
        // }
        totalVolume += volume;
        result.volumes[i] = volume;

        if (volume === 0.0) {
          //clip.pause();
        } else {
          //clip.play();
        }
        // if (volume > maxVolume) {
        //   //maxVolume = volume;
        //   //maxVolumeIndex = i;
        // }
        clip.volume(volume * baseVolumes[i]);
      }

      for (let i = 0; i < result.clips.length; ++i) {
        const clip = result.clips[i];
        clip.volume(result.volumes[i] / totalVolume  * baseVolumes[i]);
        //clip.volume(i == maxVolumeIndex ? 1.0 : 0.0);
      }
    
    }

  };


  return result;
}
window.testCreateMultipleClips = createMultipleClips;


//<Drift>
export function play_drift() : void {
  if (data.drift != null) {
    data.drift.play();
    //console.log("audio:play_drift(1)");
    return;
  }

  //let srcs : Array<string>, loop?:boolean, values? :Array<number>, extensions? : Array<string>, damp? : number
  data.drift = createMultipleClips({
    srcs : ["drift_low", "drift_middle", "drift_high"], 
    loop : true, 
    extensions : ["webm", "ogg", "aac"], 
    min : [0.0, 0.5, 0.9],
    max : [0.5, 0.9, 1.0],
    volumes : [1.0, 0.75, 0.75],
    
    damp : 0.0} );
  data.drift.play();
  window.testDrift = data.drift;
  //console.log("audio:play_drift");
}

export function set_drift_rate(value:number) : void {
  if (data.drift != null && data.drift.playing()) {
    //console.log("audio:set_drift_rate", value);
    data.drift.setValue(value);
  }
}

export function playing_drift() : boolean {
  return data.drift != null && data.drift.playing();
}

export const max_speed = 80;
export const max_speed_interval = 40;

export function stop_drift() : void {
  
  if (data.drift != null && data.drift.isPlaying) {
    console.log("audio: stop_drift");
    data.drift.stop();
  }
}
//</Drift>
export function play_motor() : void {
  if (data.motor != null) {
    data.motor.play();
    //console.log("audio:play_motor(1)");
    return;
  }
  //var srcs = [];
  var srcs = [
    "0kph",
    "40kph",
    "60kph",
    "80kph",

   ];
  // for (var i = 0; i <= max_speed; i+= max_speed_interval) {
  //   srcs.push(i + "kph");
  // }

  //let srcs : Array<string>, loop?:boolean, values? :Array<number>, extensions? : Array<string>, damp? : number
  data.motor = createMultipleClips({
    srcs : srcs, 
    loop : true, 
    extensions : ["webm", "ogg", "aac"], 
    interp: "linear",
    //volume : base_motor_volume,
    volumes : [1.0, base_motor_volume, base_motor_volume, base_motor_volume],
    damp : 0.0} );
  data.motor.play();
  data.motor.setValue(0.0);
  window.testmotor = data.motor;
  //console.log("audio:play_motor");
}
window.testPlayMotor = play_motor;

export function set_motor_rate(value:number) : void {
  if (data.motor != null && data.motor.playing()) {
    //console.log("audio:set_motor_rate", value);
    data.motor.setValue(value);
  }
}
window.testSetMotorRate = set_motor_rate;

export function set_motor_speed(value:number) : void {
  set_motor_rate(value / max_speed);
}
window.testSetMotorSpeed = set_motor_speed;


export function playing_motor() : boolean {
  return data.motor != null && data.motor.playing();
}

export function stop_motor() : void {
  
  if (data.motor != null && data.motor.isPlaying) {
    console.log("audio: stop_motor");
    data.motor.stop();
  }
}
window.testStopMotor = stop_motor;


export function play_car_welcome() : void {
  if (data.car_welcome != null) {
    data.car_welcome.stop();
    data.car_welcome.play();
    return;
  }
  data.car_welcome = new window.Howl({
    src: getSoundArray("car_welcome"),
    autoplay: false,
    loop: false,
    volume: 1.0,
  });
  data.car_welcome.play();
}


export function playBGM_UI(): void {
  if (data.bgmType === BGMTYPE_UI) {
    return;
  }
  data.bgmType = BGMTYPE_UI;
  playBGM("ui_bgm_a");
  console.log("audio: after playBGM AudioUtilsData=", data);
}

export function playBGM_UI2(): void {
  if (data.bgmType === BGMTYPE_UI2) {
    return;
  }
  data.bgmType = BGMTYPE_UI2;
  playBGM("ui_bgm");
  console.log("audio: after playBGM2 AudioUtilsData=", data);
}

export function playBGM_music(): void {
  if (data.bgmType === BGMTYPE_MUSIC) {
    return;
  }
  data.bgmType = BGMTYPE_MUSIC;
  playBGM("music_play");
  console.log("audio: after playBGM_music AudioUtilsData=", data);
  //console.log("audio: after playBGM2 AudioUtilsData=", data);
}

export function playBGM_zero100(): void {
  if (data.bgmType === BGMTYPE_ZERO100) {
    return;
  }
  data.bgmType = BGMTYPE_ZERO100;
  playBGM("zero_100_bgm");
}

export function playBGM_racing(): void {
  if (data.bgmType === BGMTYPE_RACING) {
    return;
  }
  data.bgmType = BGMTYPE_RACING;
  playBGM("racing_bgm");
}

export function stopBGM(): void {
  console.log("audio: stopBGM");
  data.bgmType = BGMTYPE_NONE;
  stopBGMImpl();
}

export function updateMuted(): void {
  if (window.soundMuted === window.globalMuted) {
    return;
  }
  window.soundMuted = window.globalMuted

  if (window.soundMuted) {
    window.Howler.volume(0.0);
  } else {
    window.Howler.volume(1.0);
  }
}

if (window.soundMuted == null) {
  window.soundMuted = false;
  setInterval(updateMuted, 1000);
}
